import { CE } from './ce';

export class PI extends CE {}
